import { render, staticRenderFns } from "./health_daily.vue?vue&type=template&id=8c56b74a&scoped=true&"
import script from "./health_daily.vue?vue&type=script&lang=js&"
export * from "./health_daily.vue?vue&type=script&lang=js&"
import style0 from "./health_daily.vue?vue&type=style&index=0&id=8c56b74a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c56b74a",
  null
  
)

export default component.exports